import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useProfileApi, useProfileStore } from '@entities/viewer'

interface TzDisplayReturn {
  refValue: ComputedRef<string>
  setTimezone: (value: string) => Promise<void>
}

export const useTzDisplay = (): TzDisplayReturn => {
  const profileStore = useProfileStore()
  const { updateViewTimezone } = useProfileApi()

  const refValue = computed<string>(() => profileStore.getTimezone)

  const setTimezone = async (value: string): Promise<void> => {
    if (!value) return
    await updateViewTimezone({ view_timezone: value })
  }

  return {
    refValue,
    setTimezone,
  }
}
